import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Product } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseQueryOptions<unknown, Error, Product>,
    'queryKey' | 'queryFn'
  >;
}

export const useProductRequest = ({
  id,
  options,
}: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, Product>(
    [Entities.Products, id],
    async () => {
      const { data } = await api.v1AdminProductsProductIdGet(id)
      return data
    },
    {
      ...options,
    },
  )
}
